import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { post, get, ajax } from "jquery";
import ContentTitle from '../../components/common/container/title';
import ElementMessage from '../../components/common/elementmessage';
import Button from '../../components/forms/button';
import InlineInput from '../../components/forms/inlineinput';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker, { registerLocale } from 'react-datepicker';
import Translate from '../../components/common/translate'
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import ja from "date-fns/locale/ja";
import { useHistory } from 'react-router-dom';

var jaLocale = {
    ...ja,
    options: {
        weekStartsOn: 0, firstWeekContainsDate: 1
    }
}
registerLocale('ja', jaLocale);
const getTranslateValue = Utils.getTranslateValue;

const API = {
    GETALLNINUSHI: window.domainDir + "api/SysDate/GetNinushiSydateDetails",
    GETALLHANSOKU: window.domainDir + "api/Home/GetAllHansoku",
    CHECKPARAMETERS: window.domainDir + "api/Pod/CheckSpotModel",
    DOWNLOADZIP: window.domainDir + "api/Pod/SpotDownload",
    CHECKIRAI: window.domainDir + "api/Billing/CheckIraiDetails"
}

const IRC0101_Master = (props) => {
    let translate = useRef(null);
    let history = useHistory();    

    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [requestId, setRequestId] = useState("");
    const [referencepassword, setReferencePassword] = useState("");
    const [translateSuccess, setTranslateSuccess] = useState(false);

    useEffect(() => {
        $("#loading").fadeIn();
        $("#loading").fadeOut();
    }, []);

    function clearMessage() {
        setStatus("");
        setMessage("");
    }

    function setStatusMessage(status, message) {
        setStatus(status);
        setMessage(message);
    }

    function getFilterParameters() {
        return {
            IraiNo: parseInt(requestId),
            ShowPassword: referencepassword
        };
    }

    function handleCheckParameters() {
        if(Utils.isNullOrEmpty(requestId.trim())){
            var str = getTranslateValue(translate.current, "messages.common.requiredinput");
            var requestIdError = str.replace("{0}",  getTranslateValue(translate.current, "views.irc0101.requestid"));
            setStatusMessage(CONST.ApiResult.Error, requestIdError);
            return;
        }

        // Request ID must be an integer
        if (!/^[0-9]+$/.test(requestId.trim())) {
            setStatusMessage(CONST.ApiResult.Error, getTranslateValue(translate.current, "views.irc0101.incorrectdetail"));
            return;
        }

        if(Utils.isNullOrEmpty(referencepassword.trim())){
            var str = getTranslateValue(translate.current, "messages.common.requiredinput");
            var referencepasswordError = str.replace("{0}",  getTranslateValue(translate.current, "views.irc0101.referencepassword"));
            setStatusMessage(CONST.ApiResult.Error, referencepasswordError);
            return;
        }

        clearMessage();
        const model = getFilterParameters();

        fetch(API.CHECKIRAI, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(model)
        })
        .then(response => response.json())
        .then(result => {
            if (result.Status === CONST.ApiResult.Success) {
                sessionStorage.setItem("bbmedical_iraino", requestId);
                sessionStorage.setItem("bbmedical_showpassword", referencepassword);
                sessionStorage.setItem("bbmedical_billingcomplete", false);
            history.push(`/Billing/Details`);
            } else {
                setStatusMessage(CONST.ApiResult.Error, result.Message);
            }
        })
        .catch(() => {
            setStatusMessage(CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
        });
    }

    return (
        <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
            <ContentTitle active="#IRC0101" title={getTranslateValue(translate.current, "views.titleText.irc0101")} />
            <div className="main-content">
                <div className="container-fluid" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    {
                        null == message || "" == message ?
                            null
                            :
                            <div style={{ marginLeft: '-20px', marginRight: '-20px', whiteSpace: 'pre-wrap' }}>
                                <ElementMessage message={message} status={status} clearMessage={clearMessage.bind(this)} />
                            </div>
                    }
                    <div style={{ marginLeft: '-20px', marginRight: '-20px', marginTop: '-10px', marginBottom: message ? '130px' : '40px', whiteSpace: 'pre-wrap' }}>
                        <div className="col-xs-12">
                            {getTranslateValue(translate.current, "views.irc0101.message")}
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-md-5 col-sm-6">
                            <InlineInput
                                label={getTranslateValue(translate.current, "views.irc0101.requestid")}
                                disabled={false}
                                maxLength="256"
                                placeholder={getTranslateValue(translate.current, "views.irc0101.requestid")}
                                value={requestId}
                                onChange={setRequestId.bind(this)}
                                orientation={CONST.OrientationX}
                                labelColName={"col-sm-3 col-md-3 input-group-text"}
                                inputColName={"col-sm-9 col-md-9"}
                            />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-md-5 col-sm-6">
                            <InlineInput
                                label={getTranslateValue(translate.current, "views.irc0101.referencepassword")}
                                disabled={false}
                                maxLength="256"
                                placeholder={getTranslateValue(translate.current, "views.irc0101.referencepassword")}
                                value={referencepassword}
                                onChange={setReferencePassword.bind(this)}
                                orientation={CONST.OrientationX}
                                labelColName={"col-sm-3 col-md-3 input-group-text"}
                                inputColName={"col-sm-9 col-md-9"}
                            />
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col-md-5 col-sm-6">
                            <div style={{ textAlign: "center" }}>
                                <Button style={{ width: "150px" }} divClassName="" className="flex-grow-0" color="Success" label={getTranslateValue(translate.current, "views.buttontext.confirm")} onClick={handleCheckParameters.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Translate>
    )
}

export default IRC0101_Master;


// WEBPACK FOOTER //
// ./view/IRC0101/irc0101.jsx